import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { CACHE_SIZE_UNLIMITED, getFirestore, initializeFirestore } from "firebase/firestore";

export const firebaseConfig = {
  apiKey: "AIzaSyBqmRhxk9-blhmvdtymsCTmlh_7TmsKx-Q",
  authDomain: "sellexx-web.firebaseapp.com",
  projectId: "sellexx-web",
  storageBucket: "sellexx-web.firebasestorage.app",
  messagingSenderId: "382287654913",
  appId: "1:382287654913:web:73a264249fe5b9710c9000",
  measurementId: "G-RHF7ZM09DT",
};

const app = initializeApp(firebaseConfig);
const db = initializeFirestore(app, {
  cacheSizeBytes: CACHE_SIZE_UNLIMITED,
});

export default db;

